import { FormProvider } from "react-hook-form"
import { useState } from "react"
import { FormField } from "../../../components/FormField"
import { useInertiaForm } from "../../../hooks/useInertiaForm"
import PreviewableVisitorView from "../../../components/PreviewableVisitorView"
import RichMdxEditor from "../../../components/RichMdxEditor"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDown, faArrowUp, faCheck, faDeleteLeft } from "@fortawesome/free-solid-svg-icons"
import { router } from "@inertiajs/react"

export default function ReferencesSectionForm({
  publishable = {},
  path
}: any) {
  const newPublishable = Object.keys(publishable).length === 0
  const [viewMode, setViewMode] = useState('content-edit')

  const {
    formMethods,
    onSubmit,
    isSubmitting,
  } = useInertiaForm({
    key: 'references_section',
    serverData: newPublishable ? {
      title: '',
      description: ''
    } : {
      title: publishable.title || '',
      description: publishable.description || ''
    },
    options: {
      url: newPublishable ? path : `${path}/${publishable.id}`,
      method: newPublishable ? 'post' : 'patch',
    }
  })

  const {
    formState: { isDirty },
    watch
  } = formMethods

  const publishableData = watch()

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this references section?')) {
      router.delete(`${path}/${publishable.id}`)
    }
  }

  const handleMoveUp = () => {
    router.post(`${path}/${publishable.id}/move_up`)
  }

  const handleMoveDown = () => {
    router.post(`${path}/${publishable.id}/move_down`)
  }

  return (
    <FormProvider {...formMethods}>
      <form
        onSubmit={onSubmit}
        onKeyDown={(e) => {
          if (e.shiftKey && e.key === 'Enter') {
            e.preventDefault()
            onSubmit(e)
          }
        }}
        style={{
          backgroundColor: 'white',
          height: '100%',
          border: '2px solid #ddd',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <div style={{
          width: '100%',
          backgroundColor: '#f5f5f5',
          borderBottom: '2px solid #ddd',
          padding: '4px',
          fontWeight: 'bold',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '4px',
              paddingBottom: '4px',
            }}>
              {newPublishable ? 'New References Section' : (
                <>
                  <span>{publishable.title}</span>
                  <div
                    className="tooltip tooltip-bottom cursor-pointer"
                    data-tip="Delete"
                    onClick={handleDelete}
                  >
                    <FontAwesomeIcon icon={faDeleteLeft} />
                  </div>
                  <div
                    className="tooltip tooltip-bottom cursor-pointer"
                    data-tip="Move up"
                    onClick={handleMoveUp}
                  >
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      className="text-sm"
                    />
                  </div>
                  <div
                    className="tooltip tooltip-bottom cursor-pointer"
                    data-tip="Move down"
                    onClick={handleMoveDown}
                  >
                    <FontAwesomeIcon
                      icon={faArrowDown}
                      className="text-sm"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            {isDirty && (
              <button
                type="button"
                onClick={() => window.location.reload()}
                disabled={isSubmitting}
                className="btn btn-sm"
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="btn btn-sm btn-success"
              disabled={isSubmitting || !isDirty}
            >
              {isSubmitting ? 'Saving...' : 'Save'}
              <FontAwesomeIcon icon={faCheck} />
            </button>
          </div>
        </div>

        <div style={{
          padding: '4px',
          borderBottom: '1px solid #ddd',
          backgroundColor: 'white',
        }}>
          <FormField.Container style={{
            backgroundColor: 'var(--color-base-300)',
            padding: '4px',
            display: 'flex',
            flexDirection: 'row',
          }}>
            <FormField.Field
              name="title"
              label="Title"
              placeholder="Reference Section Title"
              registerProps={{ required: true }}
            />

            <div style={{
              marginLeft: 'auto',
            }}>
              <FormField.Select
                label="View Mode"
                value={viewMode}
                onChange={(e) => setViewMode(e.target.value)}
              >
                <option disabled={true}>View mode</option>
                <option value="content-edit">Edit Content</option>
                <option value="visitor-view">Preview</option>
              </FormField.Select>
            </div>
          </FormField.Container>
        </div>
        <div style={{
          flex: 1,
          overflow: 'auto',
          minHeight: 0,
        }}>
          {viewMode === 'content-edit' && (
            <RichMdxEditor
              key={`references-section-${publishable.id}-description-preview`}
              name="description"
            />
          )}
          {viewMode === 'visitor-view' && (
            <div style={{
              padding: '4px'
            }}>
              <PreviewableVisitorView
                publishable={publishableData}
              />
            </div>
          )}
        </div>
      </form>
    </FormProvider>
  )
}
